<template>
    <div>
        <div>
            <el-row :gutter="6" class="dy-wrp">
                <el-col :span="8">
                    <label>开始时间:</label>
                    <el-date-picker v-model="starttime" type="date" value-format="yyyy-MM-dd"
                        placeholder="选择日期"></el-date-picker>
                </el-col>
                <el-col :span="8">
                    <label>结束时间:</label>
                    <el-date-picker v-model="endtime" type="date" value-format="yyyy-MM-dd"
                        placeholder="选择日期"></el-date-picker>
                </el-col>
                <el-col :span="3">
                    <el-button type="primary" @click="pullList">查询</el-button>
                </el-col>
            </el-row>
        </div>
        <h3>区间统计 <span class="txt-tips">(仅供参考，数据有偏差)</span></h3>
        <el-table :data="orders" stripe tooltip-effect="dark" fit>
            <el-table-column label="企业名称">
                <template slot-scope="scope">{{ scope.row.TravelCompany_Name }}</template>
            </el-table-column>
            <el-table-column label="投保人数">
                <template slot-scope="scope">{{ scope.row.TravelCompany_PersonCount }}</template>
            </el-table-column>
            <el-table-column label="保费金额">
                <template slot-scope="scope">{{ scope.row.TravelCompany_MoneyCount }}</template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            starttime: "",
            endtime: "",
            orders: [],
        };
    },
    mounted() {
        this.pullList();
    },
    methods: {
        pullList() {
            this.ipost(
                "/AdminTravel/TravelCompany.ashx?type=statisduration",
                {
                    starttime: this.starttime,
                    endtime: this.endtime,

                },
                (res) => {
                    console.log("res:", res);
                    this.orders = res.list;
                }
            );
        }
    },
};
</script>

<style scoped>
.dy-wrp label {
    margin: 10px 0;
    line-height: 40px;
}

.txt-tips {
    font-weight: normal;
    font-size: 13px;
    color: #666;
}

.el-collapse-item .el-row {
    padding: 6px 12px;
}

.search-wrp .el-input {
    width: 60%;
    margin-right: 10px;
}

.el-pagination {
    margin: 16px auto;
    text-align: center;
}
</style>